import styled from 'styled-components';
import { variant } from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { ComponentVariants } from './type';

export const PageHeaderSubtitleWrapper = styled.div<{
  variant?: ComponentVariants;
}>`
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'PageHeaderSubtitle', 'variant')
    )};
`;

PageHeaderSubtitleWrapper.defaultProps = {
  variant: 'regular',
};
